// @ts-expect-error dependency missing types
import { threadHistoryToMessageList } from 'conversations-message-history/thread-history/operators/threadHistoryToMessageList';
// @ts-expect-error dependency missing types
import { getPubSubMessage } from 'conversations-message-history/unpublished-messages/operators/getPubSubMessage';
import { connect } from 'react-redux';
import { selectQuickReplyOptionOutsideChat } from '../actions/selectQuickReplyOptionOutsideChat';
// @ts-expect-error dependency missing types
import { publishVisitorMessage } from '../pubsub/actions/publishVisitorMessage';
import { getMessageResultsFromStagedThread } from '../quick-reply/operators/getMessageResultsFromStagedThread';
import getQuickReplyOptionsFromStagedThreadMessages from '../quick-reply/operators/getQuickReplyOptionsFromStagedThreadMessages';
import QuickReplyGroupOutsideChatCore from 'conversations-visitor-experience-components/visitor-widget/components/QuickReplyGroupOutsideChat';
// @ts-expect-error dependency missing types
import { getColoring } from '../selectors/widgetDataSelectors/getColoring';
import { showQuickReplyOutsideChat } from '../utils/showQuickRepliesOutsideChat';
// @ts-expect-error untyped file
import { consentToProcess as onConsentToProcess } from '../gdpr/actions/visitorConsentsToProcess';
// @ts-expect-error untyped file
import { getConsentToProcessMessage } from '../gdpr/selectors/getConsentToProcessMessage';
// @ts-expect-error untyped file
import { getShowGdprConsentToProcess } from '../gdpr/selectors/getShowGdprConsentToProcess';
// @ts-expect-error untyped file
import { getGdprConsentToProcessEnabledForChatflow } from '../gdpr/selectors/getGdprConsentToProcessEnabledForChatflow';
// @ts-expect-error untyped file
import { getUserHasGivenConsentToProcess } from '../gdpr/selectors/getHasUserGivenConsentToProcess';
// @ts-expect-error untyped file
import { shouldRequireExplicitCookieConsent } from '../selectors/widgetDataSelectors/shouldRequireExplicitCookieConsent';
// @ts-expect-error untyped file
import { consentToCookies as onCensentToCookies } from '../gdpr/actions/visitorConsentsToCookies';
// @ts-expect-error untyped file
import { declineCookies as onDeclineCookies } from '../gdpr/actions/visitorDeclinesCookies';
// @ts-expect-error untyped file
import { getIsPortal53 } from '../widget-data/operators/getIsPortal53';
import { isOneOfTargetedProductPages as getIsOneOfTargetedProductPages } from '../query-params/getIsOneOfTargetedProductPages';
import { closeConsentToProcess as closeConsentToProcessAction } from '../gdpr/actions/visitorClosesConsentToProcess';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
export const QuickReplyGroupOutsideChat = ({
  quickReplyOptions,
  setQuickReplyGroupOutsideChatRef,
  widgetLocation = 'RIGHT_ALIGNED',
  onQuickReplyOptionClick = noop,
  message,
  widgetColoring,
  publishMessage,
  displayBotQuickRepliesOutsideChat,
  showGdprConsentToProcessButton,
  consentToProcessMessage,
  consentToProcess,
  showingGdprProcess,
  renderCookieConsentPrompt,
  consentToCookies,
  declineCookies,
  isPortal53,
  closeConsentToProcess,
  isOneOfTargetedProductPages
}) => {
  return /*#__PURE__*/_jsx(QuickReplyGroupOutsideChatCore, {
    quickReplyOptions: quickReplyOptions,
    setQuickReplyGroupOutsideChatRef: setQuickReplyGroupOutsideChatRef
    // TODO: Remove this props from the component
    ,
    onIframeResize: () => {},
    widgetLocation: widgetLocation,
    widgetColoring: widgetColoring,
    displayBotQuickRepliesOutsideChat: displayBotQuickRepliesOutsideChat,
    message: message,
    onQuickReplyOptionClick: onQuickReplyOptionClick,
    publishMessage: publishMessage,
    showGdprConsentToProcessButton: showGdprConsentToProcessButton,
    consentToProcessMessage: consentToProcessMessage,
    consentToProcess: consentToProcess,
    showingGdprProcess: showingGdprProcess,
    renderCookieConsentPrompt: renderCookieConsentPrompt,
    consentToCookies: consentToCookies,
    declineCookies: declineCookies,
    isPortal53: isPortal53,
    closeConsentToProcess: closeConsentToProcess,
    isOneOfTargetedProductPages: isOneOfTargetedProductPages
  });
};
QuickReplyGroupOutsideChat.displayName = 'QuickReplyGroupOutsideChat';
const mapStateToProps = state => {
  const messageResults = getMessageResultsFromStagedThread(state);
  const quickReplyOptions = getQuickReplyOptionsFromStagedThreadMessages(messageResults);
  const widgetColoring = getColoring(state);
  const messageRecords = threadHistoryToMessageList(state.stagedThread.data);
  const message = getPubSubMessage(messageRecords.last());
  const displayBotQuickRepliesOutsideChat = showQuickReplyOutsideChat(state);
  const consentToProcessMessage = getConsentToProcessMessage(state);
  const showGdprConsentToProcessButton = getShowGdprConsentToProcess(state);
  const showingGdprProcess = getGdprConsentToProcessEnabledForChatflow(state) && !getUserHasGivenConsentToProcess(state);
  const renderCookieConsentPrompt = shouldRequireExplicitCookieConsent(state);
  const isPortal53 = getIsPortal53();
  const isOneOfTargetedProductPages = getIsOneOfTargetedProductPages();
  return {
    displayBotQuickRepliesOutsideChat,
    quickReplyOptions,
    widgetColoring,
    message,
    consentToProcessMessage,
    showGdprConsentToProcessButton,
    showingGdprProcess,
    renderCookieConsentPrompt,
    isPortal53,
    isOneOfTargetedProductPages
  };
};
const mapDispatchToProps = {
  onQuickReplyOptionClick: selectQuickReplyOptionOutsideChat,
  publishMessage: publishVisitorMessage,
  consentToProcess: onConsentToProcess,
  consentToCookies: onCensentToCookies,
  declineCookies: onDeclineCookies,
  closeConsentToProcess: closeConsentToProcessAction
};
export default connect(mapStateToProps, mapDispatchToProps)(QuickReplyGroupOutsideChat);